import { __decorate } from "tslib";
import { Getter, State } from 'vue-class-state';
import { docService } from "../../services/docService";
let instance = null;
export class DocState {
  constructor() {
    this.docs = [];
    this.types = [{
      id: 'var',
      name: '平台变量',
      _sort: 100
    }];
    this.currentType = 'var';
    this.searchKeyword = '';
    this.init();
  }
  static getInstance() {
    if (!instance) {
      instance = new DocState();
    }
    return instance;
  }
  get docTypes() {
    return this.types.map(type => ({
      ...type,
      docs: this.docs.filter(item => item.type === type.id)
    }));
  }
  get docTypesInSearch() {
    const {
      searchKeyword
    } = this;
    return this.docTypes.map(({
      id,
      name,
      docs
    }) => ({
      id,
      name,
      docs: docs.filter(item => item.title.includes(searchKeyword) || item.content.includes(searchKeyword) || item.keywords.some(k => k === searchKeyword))
    }));
  }
  get docsToShow() {
    return this.docs.filter(item => item.type === this.currentType);
  }
  async init() {
    const [docs, types] = await Promise.all([docService.list(), docService.docTypeList()]);
    this.docs = docs;
    this.types = types;
  }
  setDocType(type) {
    this.currentType = type;
  }
  /**
   * 根据当前行，提示文档
   */
  hit(_codeLineString) {
    // todo
  }
}
__decorate([State], DocState.prototype, "docs", void 0);
__decorate([State], DocState.prototype, "types", void 0);
__decorate([State], DocState.prototype, "currentType", void 0);
__decorate([Getter], DocState.prototype, "docTypes", null);
__decorate([Getter], DocState.prototype, "docTypesInSearch", null);
__decorate([Getter], DocState.prototype, "docsToShow", null);
__decorate([State], DocState.prototype, "searchKeyword", void 0);
//# sourceMappingURL=DocState.js.map
